



import { defineComponent } from "@vue/composition-api";
import Vue, { VueConstructor } from "vue";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import { getTransactionItem } from "./Transaction";

export default defineComponent({
  name: "TransactionItem",
  props: {
    transaction: { type: Object as () => Transaction, required: true },
  },
  computed: {
    itemComponent(): VueConstructor<Vue> {
      return getTransactionItem(this.transaction);
    },
  },
});
